module.exports = __webpack_public_path__ + "static/media/nike-eor-lost-2.d2e8a7c6.jpg";